export default "__VITE_ASSET__DZ1EQcV2__"